<template lang="pug">
    //- .trigger(
    //-     v-observe-visibility='{callback: triggerVisibilityChanged}',
    //-     :class='{bottom: position === "bottom", short: short}',
    //-     ref='triggerMenu'
    //-     )
    .trigger-cnt
        .trigger.trigger_lenta(
            v-observe-visibility='{callback: triggerVisibilityChanged}',
            data-elem='header__logo'
            )
        .trigger.trigger_vc(
            v-observe-visibility='{callback: triggerVisibilityChanged}',
            data-elem='volume-control'
            )
        .trigger.trigger_ui-btns(
            v-observe-visibility='{callback: triggerVisibilityChanged}',
            data-elem='ui-btns'
            )
        
</template>

<script>
export default {
    name: 'ScrollTrigger',
    props: {
        color: {
            type: String,
            default: 'white'
        },
        position: {
            type: String,
            default: 'top'
        },
        short: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        triggerVisibilityChanged(isVisible, elem) {
            if (!isVisible) return;
            let elemClass = elem.target.getAttribute('data-elem');
            this.invertColor(elemClass);
            // if (this.color === 'white' || this.color === 'color') {
            //     this.$store.commit('setTheme', 'black');
            // } else {
            //     this.$store.commit('setTheme', 'white');
            // }
        },
        invertColor(elem) {
            if (this.color === 'black') {
                document.getElementsByClassName(elem).forEach(element => {
                    element.classList.remove('color-invert');
                });
                return;
            }
            document.getElementsByClassName(elem).forEach(element => {
                element.classList.add('color-invert');
            });
            return;
        }
    }
};
</script>

<style lang="scss" scoped>
// .trigger {
//     position: absolute;
//     width: 100%;
//     pointer-events: none;
//     height: calc(100vh - 50px);

//     &.short {
//         top: 0;
//         height: calc(100vh - 50px);
//     }

//     &.bottom {
//         // height: 50px;
//         bottom: 0;

//         @media (--viewport-tablet) {
//             height: 0;
//         }
//     }
// }
.trigger {
    pointer-events: none;
    position: absolute;
    left: 0;
    right: 0;
    &_vc {
        top: calc(var(--vh) * 5);
        bottom: calc(var(--vh) * 95);
    }
    &_lenta {
        top: calc(var(--vh) * 100);
        bottom: 0;
    }
    &_ui-btns {
        top: calc(var(--vh) * 100 - 28px);
        bottom: 28px;
    }
}
</style>
